import { useDispatch, useSelector } from "react-redux"
import { loginData, logout } from "../../stores/auth"
import { useEffect, useRef, useState } from "react"
import { decodeToken } from "../../helpers"

const useAvatar = () => {
    const modalRef = useRef()
    const dispatch = useDispatch()
    const dataLogin = useSelector(loginData)
    const [isSuperUser, setIsSuperUser] = useState(false)
    const [isAdminSatkerUser, setIsAdminSatkerUser] = useState(false)
    const [isSubmitTrueOrFalse, setIsSubmitTrueOrFalse] = useState(false)
    const [dataTrueOrFalseModal, setDataTrueOrFalseModal] = useState({
        id: null,
        title: "",
        description: "",
    })

    useEffect(() => {
        const tokenData = decodeToken(dataLogin.token_account)
        if (tokenData.is_admin && tokenData.roles) {
            const kode_role = tokenData.roles.find(role => role.kode_aplikasi === "account")['kode_role']
            setIsSuperUser(kode_role === "1")
            setIsAdminSatkerUser(kode_role === "2")
        }
    }, [])

    const handleOpenTrueOrFalseModal = () => {
        setDataTrueOrFalseModal({
            title: "Keluar",
            description: "Anda yakin keluar dari E-Office Web?"
        })
        setTimeout(() => {
            const modal = new window.bootstrap.Modal(modalRef.current);
            modal.show();
        }, 100);
    }

    const handleSubmitTrueOrFalse = async (e) => {
        dispatch(logout())
    }

    return {
        modalRef,
        isSuperUser,
        isSubmitTrueOrFalse,
        dataTrueOrFalseModal,
        handleSubmitTrueOrFalse,
        handleOpenTrueOrFalseModal,
        isAdminSatkerUser, setIsAdminSatkerUser
    }
}
export default useAvatar